import CloseIcon from "@mui/icons-material/Close";
import { Button, Typography } from "@mui/material";
import { type FC } from "react";

import { useFiltersScope } from "~/components/filters/FiltersScope";

export const ResetFiltersButton: FC = () => {
  const { clearAllFilters, isFiltersApplied } = useFiltersScope();

  if (!isFiltersApplied) return null;

  return (
    <Button
      variant="text"
      size="small"
      onClick={clearAllFilters}
      startIcon={<CloseIcon sx={{ fontSize: 14 }} />}
      sx={{
        color: "info.main",
        flexShrink: 0,
        borderRadius: 999,
        px: 1.25,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontWeight: "600",
          textTransform: "none"
        }}>
        Clear
      </Typography>
    </Button>
  );
};
